import { render, staticRenderFns } from "./HoursDashboard.vue?vue&type=template&id=91e7aff2&scoped=true&"
import script from "./HoursDashboard.js?vue&type=script&lang=js&"
export * from "./HoursDashboard.js?vue&type=script&lang=js&"
import style0 from "./HoursDashboard.scss?vue&type=style&index=0&id=91e7aff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e7aff2",
  null
  
)

export default component.exports